import useSeo from "@/lib/useSeo";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import VCHero from "@/components/visibility/VCHero";
import VCHowItWorks from "@/components/visibility/VCHowItWorks";
import VCFramework from "@/components/visibility/VCFramework";
import VCMeasures from "@/components/visibility/VCMeasures";
import VCSampleQuestions from "@/components/visibility/VCSampleQuestions";
import VCWhy from "@/components/visibility/VCWhy";
import VCReceive from "@/components/visibility/VCReceive";
import VCFAQ from "@/components/visibility/VCFAQ";
import VCCTA from "@/components/visibility/VCCTA";

export default function VisibilityCheckPage() {
  useSeo({
    title:
      "Visibility Check™ — ED Tech Depot | Free 5-Minute School Leadership Diagnostic",
    description:
      "Take the Visibility Check™ and discover your school's Visibility Score™. A free 5-minute assessment for K-12 leaders covering student recognition, communication, school culture, event promotion, and staff empowerment.",
    path: "/visibility-check",
  });

  return (
    <div data-testid="visibility-check-page" className="min-h-screen bg-[#F4F6F4]">
      <Header />
      <main>
        <VCHero />
        <VCHowItWorks />
        <VCFramework />
        <VCMeasures />
        <VCSampleQuestions />
        <VCWhy />
        <VCReceive />
        <VCFAQ />
        <VCCTA />
      </main>
      <Footer />
    </div>
  );
}
